import { useTheme } from "../../hooks/useTheme";
import { HiSun, HiMoon } from "react-icons/hi";

function ThemeToggle() {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`group relative inline-flex h-8 w-[64px] flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-all duration-500 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:ring-offset-2 dark:focus:ring-offset-slate-900 ${
        isDarkMode 
          ? "bg-slate-800 shadow-[inset_0_2px_4px_rgba(0,0,0,0.3)]" 
          : "bg-slate-200 shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)]"
      }`}
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
    >
      <span className="sr-only">Toggle theme</span>
      
      {/* Sliding Thumb */}
      <span
        className={`pointer-events-none relative flex h-7 w-7 transform items-center justify-center rounded-full shadow-[0_2px_8px_rgba(0,0,0,0.2)] ring-0 transition duration-500 ease-[cubic-bezier(0.34,1.56,0.64,1)] z-10 my-auto ml-[1px] ${
          isDarkMode ? "translate-x-[32px] bg-slate-700" : "translate-x-0 bg-white"
        }`}
      >
        <div className="relative h-full w-full flex items-center justify-center">
          <HiSun 
            className={`absolute h-4.5 w-4.5 text-primary-500 transition-all duration-500 ${
              isDarkMode ? "opacity-0 scale-0 rotate-90" : "opacity-100 scale-100 rotate-0"
            }`}
          />
          <HiMoon 
            className={`absolute h-4 w-4 text-primary-400 transition-all duration-500 ${
              isDarkMode ? "opacity-100 scale-100 rotate-0" : "opacity-0 scale-0 -rotate-90"
            }`}
          />
        </div>
      </span>
      
      {/* Subtle Glow Effect on Hover/Active */}
      <div className={`absolute inset-0 rounded-full transition-opacity duration-500 pointer-events-none group-hover:opacity-100 opacity-0 ${
        isDarkMode 
          ? "shadow-[0_0_15px_rgba(201,138,46,0.2)]" 
          : "shadow-[0_0_15px_rgba(201,138,46,0.1)]"
      }`} />
    </button>
  );
}

export default ThemeToggle;
